import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { Model } from 'app/model/backendmodel';
import { OracleFusionLinkedService } from 'app/model/linkedservice/oracle-fusion.linkedservice';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(OracleFusionLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: '*',
            parameters: '*'
        }
    }
})
export class OracleFusionLinkedServiceAdapter extends LinkedServiceAdapter<OracleFusionLinkedService> {
    protected modelConstructor(): new () => OracleFusionLinkedService {
        return OracleFusionLinkedService;
    }

    protected model(): IModel {
        return OracleFusionLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(
        linkedService: OracleFusionLinkedService,
        linkedServiceResource: Model.LinkedServiceResource
    ): Promise<Model.LinkedServiceResource> {
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(
        linkedServiceResource: Model.LinkedServiceResource,
        linkedService: OracleFusionLinkedService
    ): Promise<OracleFusionLinkedService> {
        return linkedService;
    }
}